import { render } from "./SegmentedControl.vue?vue&type=template&id=4737b10c&scoped=true&ts=true"
import script from "./SegmentedControl.vue?vue&type=script&lang=ts"
export * from "./SegmentedControl.vue?vue&type=script&lang=ts"

import "./SegmentedControl.vue?vue&type=style&index=0&id=4737b10c&lang=scss&scoped=true"
import "./SegmentedControl.vue?vue&type=style&index=1&id=4737b10c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4737b10c"]])

export default __exports__